export default "__VITE_ASSET__9sstxuBZ__"